export type HelpLocation = {
  query: string;
  categoryId: string | null;
  articleId: string | null;
};

export type SearchableHelpArticle = {
  id: string;
  title: string;
  summary: string;
  answer: string;
  stage: string;
  categoryLabel: string;
};

export function normalizeHelpQuery(value: string) {
  return value.trim().toLocaleLowerCase();
}

export function searchHelpArticles<T extends SearchableHelpArticle>(articles: readonly T[], query: string) {
  const normalizedQuery = normalizeHelpQuery(query);
  if (!normalizedQuery) return [];
  return articles.filter((article) =>
    normalizeHelpQuery(
      `${article.title} ${article.summary} ${article.answer} ${article.stage} ${article.categoryLabel}`,
    ).includes(normalizedQuery),
  );
}

export function readHelpLocation(
  search: string,
  hash: string,
  validCategoryIds: ReadonlySet<string>,
  validArticleIds: ReadonlySet<string>,
): HelpLocation {
  const params = new URLSearchParams(search);
  const query = params.get("q")?.trim() ?? "";
  const requestedCategory = params.get("category");
  const requestedArticle = params.get("article") || decodeURIComponent(hash.replace(/^#/, ""));
  return {
    query,
    categoryId: requestedCategory && validCategoryIds.has(requestedCategory) ? requestedCategory : null,
    articleId: requestedArticle && validArticleIds.has(requestedArticle) ? requestedArticle : null,
  };
}

export function buildHelpLocation({ query, categoryId, articleId }: HelpLocation) {
  const params = new URLSearchParams();
  if (query.trim()) params.set("q", query.trim());
  if (!query.trim() && categoryId) params.set("category", categoryId);
  const search = params.size ? `?${params.toString()}` : "";
  const hash = articleId ? `#${encodeURIComponent(articleId)}` : "";
  return `/help-center${search}${hash}`;
}
